import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import jaTranslation from './locales/ja/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ja: {
        translation: jaTranslation,
      },
    },
    lng: 'ja', // default language - always Japanese
    fallbackLng: 'ja', // fallback to Japanese if translation is missing
    supportedLngs: ['ja'], // only support Japanese
    nonExplicitSupportedLngs: false, // don't auto-detect browser language
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense to avoid issues with lazy loading
    },
    // Enable debug in development
    debug: import.meta.env.DEV,
  });

export default i18n;

